import React from 'react';
// styles
import styled from 'styled-components';

const CheckCircleIcon = ({ className, ...props }) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    role="img"
    aria-label="Check circle"
  >
    <g clipPath="url(#clip0_388_15714)">
      <path
        d="M49.28 17.1973C48.9278 16.9377 48.5278 16.75 48.103 16.645C47.6782 16.54 47.2369 16.5197 46.8042 16.5853C46.3716 16.651 45.9561 16.8012 45.5816 17.0275C45.207 17.2537 44.8807 17.5516 44.6213 17.904L28.824 39.344L18.7787 31.3067C18.086 30.7761 17.2131 30.538 16.347 30.6434C15.4809 30.7488 14.6906 31.1893 14.1454 31.8705C13.6003 32.5517 13.3437 33.4193 13.4306 34.2875C13.5176 35.1556 13.9412 35.9552 14.6107 36.5147L27.3653 46.7173C27.7178 46.993 28.1217 47.1957 28.5533 47.3135C28.985 47.4314 29.4358 47.462 29.8795 47.4037C30.3231 47.3454 30.7507 47.1992 31.1372 46.9737C31.5237 46.7483 31.8615 46.4481 32.1307 46.0907L49.9973 21.8587C50.2565 21.5056 50.4435 21.1049 50.5477 20.6794C50.652 20.254 50.6713 19.8122 50.6047 19.3793C50.5381 18.9464 50.3868 18.5309 50.1595 18.1565C49.9322 17.7821 49.6333 17.4562 49.28 17.1973Z"
        fill="#0140CD"
      />
      <path
        d="M32 0C25.671 0 19.4841 1.87677 14.2218 5.39297C8.95939 8.90918 4.85787 13.9069 2.43587 19.7541C0.0138652 25.6014 -0.619842 32.0355 0.614886 38.2429C1.84961 44.4503 4.89732 50.1521 9.3726 54.6274C13.8479 59.1027 19.5497 62.1504 25.7571 63.3851C31.9645 64.6199 38.3987 63.9862 44.2459 61.5642C50.0931 59.1421 55.0908 55.0406 58.607 49.7783C62.1233 44.5159 64 38.329 64 32C63.9908 23.5159 60.6165 15.3819 54.6173 9.38272C48.6181 3.38354 40.4841 0.00917622 32 0V0ZM32 58.6667C26.7259 58.6667 21.5701 57.1027 17.1848 54.1725C12.7995 51.2424 9.38157 47.0776 7.36323 42.2049C5.34489 37.3322 4.8168 31.9704 5.84574 26.7976C6.87468 21.6248 9.41443 16.8732 13.1438 13.1438C16.8732 9.41442 21.6248 6.87467 26.7976 5.84573C31.9704 4.81679 37.3322 5.34488 42.2049 7.36321C47.0776 9.38155 51.2424 12.7995 54.1725 17.1848C57.1027 21.5701 58.6667 26.7258 58.6667 32C58.6589 39.0701 55.8469 45.8483 50.8476 50.8476C45.8483 55.8469 39.0701 58.6589 32 58.6667Z"
        fill="#0140CD"
      />
    </g>
    <defs>
      <clipPath id="clip0_388_15714">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default styled(CheckCircleIcon)``;
